module.exports = __webpack_public_path__ + "img/RASolidA.4d9a2f11.jpeg";